import * as React from 'react';
import cn from 'classnames';
import { menuClasses } from './menu';
export var MenuDivider = function MenuDivider() {
  var classNames = cn(menuClasses.DIVIDER);
  return React.createElement("div", {
    className: classNames
  });
};
MenuDivider.displayName = 'MenuDivider';
MenuDivider.defaultProps = {};